export const REACT_APP_AUTHENTICATE_TOKEN_NAME =
  process.env.REACT_APP_AUTHENTICATE_TOKEN_NAME;

export const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;

export const REACT_APP_GATEWAY_URL = process.env.REACT_APP_GATEWAY_URL;

export const REACT_APP_CALL_SERVICE_URL =
  process.env.REACT_APP_CALL_SERVICE_URL;

export const REACT_APP_COMS_BASE_URL = process.env.REACT_APP_COMS_BASE_URL;

// export const REACT_APP_OMS_PROD_BASE_URL = process.env.REACT_APP_OMS_PROD_BASE_URL
export const REACT_APP_OMS_BASE_URL = process.env.REACT_APP_OMS_BASE_URL;

export const MAX_CHAR_LIMIT = 200;
export const ORDER_CANCELLATION_REQUESTED_STATUS_ID = 4;
export const ORDER_CANCELLED_STATUS_ID = 5;
export const ORDER_MODIFICATION_STATUS_ID = 6;
export const ONE_HOUR = 1000 * 60 * 60;

export const CONSTANTS = {
  ZERO: 0,
  ONE: 1,
};
